import { ElementRef, EventEmitter } from '@angular/core';
import { SelfScanTrendModalComponent } from '../wellbeing-result/self-scan-trend/self-scan-trend-modal.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WellbeingResultDetailsComponent } from '../wellbeing-result/wellbeing-result-details/wellbeing-result-details.component';
import { UserService } from '../../core/user/user.service';
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
import * as i2 from "../../core/user/user.service";
import * as i3 from "@angular/common";
import * as i4 from "@fortawesome/angular-fontawesome";
import * as i5 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i6 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i7 from "../wellbeing-result/wellbeing-result-badge/wellbeing-result-badge.component";
import * as i8 from "@angular/forms";
import * as i9 from "../auto-direction-switch/input-auto-direction-switch.directive";
import * as i10 from "../language/find-flag-code-from-key.pipe";
import * as i11 from "../language/find-language-from-key.pipe";
import * as i12 from "@ngx-translate/core";
const _c0 = ["reportClientModal"];
function UserInfoComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵlistener("click", function UserInfoComponent_div_0_div_2_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.onLeftArrowClick.emit(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 13);
    i0.ɵɵelement(3, "use", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UserInfoComponent_div_0_a_6__svg_use_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 18);
} }
function UserInfoComponent_div_0_a_6__svg_use_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 19);
} }
function UserInfoComponent_div_0_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("click", function UserInfoComponent_div_0_a_6_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.flagUser(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 15);
    i0.ɵɵtemplate(2, UserInfoComponent_div_0_a_6__svg_use_2_Template, 1, 0, "use", 16);
    i0.ɵɵtemplate(3, UserInfoComponent_div_0_a_6__svg_use_3_Template, 1, 0, "use", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.user.flagged);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.user.flagged);
} }
function UserInfoComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵlistener("click", function UserInfoComponent_div_0_div_7_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.onRightArrowClick.emit(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 21);
    i0.ɵɵelement(3, "use", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UserInfoComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵlistener("click", function UserInfoComponent_div_0_div_8_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.onCloseIconClick.emit(); });
    i0.ɵɵelement(2, "fa-icon", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UserInfoComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, UserInfoComponent_div_0_div_2_Template, 4, 0, "div", 6);
    i0.ɵɵelementStart(3, "h3", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵtemplate(6, UserInfoComponent_div_0_a_6_Template, 4, 2, "a", 9);
    i0.ɵɵtemplate(7, UserInfoComponent_div_0_div_7_Template, 4, 0, "div", 10);
    i0.ɵɵtemplate(8, UserInfoComponent_div_0_div_8_Template, 3, 0, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showLeftArrow);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("text-danger", ctx_r0.user.flagged);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.user.login);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.session);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showRightArrow);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showCloseIcon);
} }
function UserInfoComponent_div_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
} }
function UserInfoComponent_div_1_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "span", 31);
    i0.ɵɵelement(2, "ngx-emoji", 32);
    i0.ɵɵpipe(3, "findFlagCodeFromKey");
    i0.ɵɵelementStart(4, "b", 33);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "findLanguageFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(3, 2, ctx_r21.session.langKey), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, ctx_r21.session.langKey));
} }
function UserInfoComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵelement(3, "span", 26);
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 25);
    i0.ɵɵelement(7, "span", 27);
    i0.ɵɵelementStart(8, "b");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, UserInfoComponent_div_1_span_10_Template, 1, 0, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, UserInfoComponent_div_1_div_11_Template, 7, 6, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.user.endedSessionCount);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("text-danger", ctx_r1.user.credits === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.user.credits);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showUserCreditAlert && ctx_r1.user.credits === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session);
} }
function UserInfoComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "a", 35);
    i0.ɵɵlistener("click", function UserInfoComponent_div_2_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.showSrqCompletedDetails(ctx_r22.srqHistory[ctx_r22.srqHistory.length - 1]); });
    i0.ɵɵelement(3, "wellbeing-result-badge", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 37);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 38);
    i0.ɵɵelementStart(8, "a", 39);
    i0.ɵɵlistener("click", function UserInfoComponent_div_2_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.openProgressModal(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 40);
    i0.ɵɵelement(10, "use", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(11, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("wellbeingResult", ctx_r2.srqHistory[ctx_r2.srqHistory.length - 1]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 2, ctx_r2.srqHistory[ctx_r2.srqHistory.length - 1].dateTaken.toDate(), "d MMM yyyy"));
} }
function UserInfoComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "div", 43);
    i0.ɵɵtext(3, " No self-scan results ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UserInfoComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelementStart(1, "div", 45);
    i0.ɵɵelementStart(2, "fa-icon", 46);
    i0.ɵɵlistener("click", function UserInfoComponent_ng_template_4_Template_fa_icon_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r27); const modal_r25 = restoredCtx.$implicit; return modal_r25.dismiss(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵelement(4, "h4", 48);
    i0.ɵɵelementStart(5, "div", 49);
    i0.ɵɵelementStart(6, "textarea", 50);
    i0.ɵɵlistener("ngModelChange", function UserInfoComponent_ng_template_4_Template_textarea_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.reasonOfFlagging = $event; });
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 49);
    i0.ɵɵelementStart(9, "button", 51);
    i0.ɵɵlistener("click", function UserInfoComponent_ng_template_4_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r27); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.reportClient(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 2, "sessionChat.placeholder.enter"));
    i0.ɵɵproperty("ngModel", ctx_r5.reasonOfFlagging);
} }
export class UserInfoComponent {
    constructor(modalService, userService) {
        this.modalService = modalService;
        this.userService = userService;
        this.minimized = false;
        this.showRightArrow = false;
        this.showLeftArrow = false;
        this.showCloseIcon = false;
        this.onRightArrowClick = new EventEmitter();
        this.onLeftArrowClick = new EventEmitter();
        this.onCloseIconClick = new EventEmitter();
        this.modalOptions = { windowClass: 'modal-window', size: 'lg', centered: true };
        this.reasonOfFlagging = '';
    }
    set user(value) {
        this._user = value;
    }
    get user() {
        return this._user;
    }
    ngOnInit() {
    }
    openProgressModal() {
        this.progressModalReference = this.modalService.open(SelfScanTrendModalComponent, {
            backdrop: false,
            size: "lg",
            windowClass: "self-scan-details-modal"
        });
        this.progressModalReference.componentInstance.selfScanModalRef = this.progressModalReference;
        this.progressModalReference.componentInstance.srqHistory = this.srqHistory;
    }
    flagUser() {
        this.modalService.open(this.reportClientModal);
    }
    showSrqCompletedDetails(srqCompleted) {
        this.srqCompletedDetailsModalReference = this.modalService.open(WellbeingResultDetailsComponent, {
            backdrop: false,
            size: "lg",
            windowClass: "self-scan-details-modal"
        });
        this.srqCompletedDetailsModalReference.componentInstance.srqHistory = this.srqHistory;
        this.srqCompletedDetailsModalReference.componentInstance.selectedSrq = srqCompleted;
    }
    reportClient() {
        this.showReasonOfFlaggingRequired = false;
        if (this.reasonOfFlagging === '') {
            this.showReasonOfFlaggingRequired = true;
            return;
        }
        this.userService.reportClient({ id: this.session.user.id, reasonOfFlagging: this.reasonOfFlagging }, this.session.id).subscribe(res => {
            this.user.flagged = true;
        }, error => console.error('client cannot be flagged: ' + error), () => {
            this.modalService.dismissAll();
        });
    }
}
UserInfoComponent.ɵfac = function UserInfoComponent_Factory(t) { return new (t || UserInfoComponent)(i0.ɵɵdirectiveInject(i1.NgbModal), i0.ɵɵdirectiveInject(i2.UserService)); };
UserInfoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserInfoComponent, selectors: [["user-info"]], viewQuery: function UserInfoComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportClientModal = _t.first);
    } }, inputs: { user: "user", srqHistory: "srqHistory", minimized: "minimized", showRightArrow: "showRightArrow", showLeftArrow: "showLeftArrow", showCloseIcon: "showCloseIcon", session: "session", showUserCreditAlert: "showUserCreditAlert" }, outputs: { onRightArrowClick: "onRightArrowClick", onLeftArrowClick: "onLeftArrowClick", onCloseIconClick: "onCloseIconClick" }, decls: 6, vars: 4, consts: [["class", "row justify-content-around mt-3 mx-2", 4, "ngIf"], ["class", "d-flex col justify-content-start mx-2 my-1", 4, "ngIf"], ["class", "row justify-content-start m-2", 4, "ngIf"], ["reportClientModal", ""], [1, "row", "justify-content-around", "mt-3", "mx-2"], [1, "col"], ["class", "d-inline-block mr-3", 4, "ngIf"], [1, "d-inline-block"], [1, "float-right"], [3, "click", 4, "ngIf"], ["class", "d-inline-block ml-3", 4, "ngIf"], [1, "d-inline-block", "mr-3"], [3, "click"], [1, "angle-icon", 2, "height", "22px", "width", "22px", "transform", "rotate(90deg)"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down"], [1, "angle-icon", 2, "height", "28px", "width", "26px"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#flag-red-fill", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#flag-red-outline", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#flag-red-fill"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#flag-red-outline"], [1, "d-inline-block", "ml-3"], [1, "angle-icon", 2, "height", "22px", "width", "22px", "transform", "rotate(-90deg)"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer"], [1, "d-flex", "col", "justify-content-start", "mx-2", "my-1"], [1, "d-flex", "justify-content-between", 2, "flex", "0 0 80%"], [1, "d-flex", "align-items-center"], ["jhiTranslate", "inukaNgApp.inukaJourney.sessions", 1, "text-light", "mr-1"], ["jhiTranslate", "sessionChat.paragraph.credits", 1, "text-light", "ml-3", "mr-1"], ["class", "text-danger ml-3 mb-1", "jhiTranslate", "sessionChat.paragraph.userInfoNoCreditAlert", 4, "ngIf"], ["class", "d-flex align-items-center", 4, "ngIf"], ["jhiTranslate", "sessionChat.paragraph.userInfoNoCreditAlert", 1, "text-danger", "ml-3", "mb-1"], ["jhiTranslate", "sessionSchedule.paragraph.language", 1, "text-light", "ml-3", "mr-2"], [3, "emoji"], [1, "ml-1"], [1, "row", "justify-content-start", "m-2"], [1, "float-left", "pr-3", 3, "click"], [3, "wellbeingResult"], [1, "float-left", "text-light", "pt-1", "pr-3", 2, "min-width", "calc(100% - 250px)"], [1, "float-left"], [1, "progress-link", 3, "click"], [2, "height", "1.1rem!important", "width", "1.3rem!important"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#progress"], ["jhiTranslate", "inukaNgApp.indexUser.wellbeingResult.progress", 1, "progress-text", "text-success", "font-weight-bold"], [1, "text-light"], [1, "olha-theme"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "text-center", "pt-0"], ["jhiTranslate", "sessionChat.header.reason"], [1, "d-flex", "justify-content-center", "mt-4"], ["inputAutoDirectionSwitch", "", "id", "session-chat-report-reason-input", "rows", "5", 1, "form-control", 2, "background", "#FDFDFD", "border", "1px solid #8A9D98", "border-radius", "10px", 3, "placeholder", "ngModel", "ngModelChange"], ["id", "session-chat-report-submit", "type", "button", "jhiTranslate", "sessionChat.button.submit", 1, "btn", "btn-primary", "m-2", 3, "click"]], template: function UserInfoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, UserInfoComponent_div_0_Template, 9, 7, "div", 0);
        i0.ɵɵtemplate(1, UserInfoComponent_div_1_Template, 12, 6, "div", 1);
        i0.ɵɵtemplate(2, UserInfoComponent_div_2_Template, 12, 5, "div", 2);
        i0.ɵɵtemplate(3, UserInfoComponent_div_3_Template, 4, 0, "div", 2);
        i0.ɵɵtemplate(4, UserInfoComponent_ng_template_4_Template, 10, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.user);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.minimized);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.srqHistory && ctx.srqHistory.length && !ctx.minimized);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.srqHistory && !ctx.srqHistory.length && !ctx.minimized);
    } }, directives: [i3.NgIf, i4.FaIconComponent, i5.JhiTranslateDirective, i6.EmojiComponent, i7.WellbeingResultBadgeComponent, i8.DefaultValueAccessor, i9.InputAutoDirectionSwitchDirective, i8.NgControlStatus, i8.NgModel], pipes: [i10.FindFlagCodeFromKeyPipe, i11.FindLanguageFromKeyPipe, i3.DatePipe, i12.TranslatePipe], styles: ["ngx-emoji[_ngcontent-%COMP%]{margin-top:5px !important}"] });
